import script from "./Divisions.vue?vue&type=script&setup=true&lang=js"
export * from "./Divisions.vue?vue&type=script&setup=true&lang=js"

import "./Divisions.vue?vue&type=style&index=0&id=aa2cb928&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa2cb928"]])

export default __exports__